import { render, staticRenderFns } from "./NewHealthProfessionals.vue?vue&type=template&id=746270dc&"
import script from "./NewHealthProfessionals.vue?vue&type=script&lang=ts&"
export * from "./NewHealthProfessionals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports